import React from 'react';
import MetaTags from "../components/MetaTags";
const KvadratStolbik: React.FC = () => {

    MetaTags(
        "Схема плетения квадратного столбика",
        "Схема плетения цепочки квадратный столбик из бисера. Она представляет собой объемный крестик. Квадратным столбиком можно плести объемные изделия."
    )

    return <>
        <h2>Схема плетения квадратного столбика</h2>
        <p>Эта цепочка представляет собой объемный крестик. Она дает большие возможности в плетении объемных изделий, <a href="/breloki-aksessuary">брелоков</a>, кулонов, геометрических фигур и
            даже букв.</p>

        <p>Возьмем леску и бисер. Желательно, чтобы бисер среднего или крупного размера или леска или иголка были достаточно тонкими, потому что через некоторые дырочки их придется продевать четыре раза.</p>
        <p>Набираем 4 бисеринки и пропускаем леску в первую из них и затягиваем колечко (рис.А,Б). Набираем еще 3 бисеринки и снова продеваем леску в первую бисеринку (рис.В). Продеваем леску во вторую бисеринку, затем набираем еще 2, а потом пропускаем леску последовательно через бисеринки 5,2 и 3 (рис.Г). Набираем еще 2 бисеринки, пропускаем леску через 8, 3 ,4 и 7ю, затем набираем еще одну 12ю бисеринку, продеваем леску через 10,7 и 4ю бисеринки (рис.Д). Стянув леску мы должны получить кубик (рис.Е).</p>

        <img src="/image/Schema/Kvadrat_stolbik.jpg" width="550" height="426" className="schema img-thumbnail col-centered img-responsive" alt="СХЕМА ПЛЕТЕНИЯ КВАДРАТНОГО СТОЛБИКА" />
            <p>Для продолжения плетения нужно пропустить леску из последней 12й бусинки в 11ю, которая теперь станет как бы 1й. Повторяются все операции по схемам на рис. В&nbsp;— Е.
                Итак 11, 6, 8 и 10я бисеринки уже готового элемента квадратной цепочки становятся 1,2,3,4й бисеринками следующего.</p>

    </>;
};

export default KvadratStolbik;

